<template>
  <v-row row wrap class="mt-2">
    <v-col cols="12" class="main">
      <v-card>
        <slot name="main"></slot>
      </v-card>
    </v-col>
    <v-col cols="12" class="bottom-button" style="position:sticky; bottom:0; padding: 12px; background: #fafafa;">
        <slot name="footer"></slot>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'SingleActionView',
  data() {
    return {};
  },

  computed: {},

  methods: {},

  async mounted() {},

  components: {

  }
};
</script>

<style lang="scss">
.bottom-button {
  position: sticky;
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;

  display: grid;

  bottom: 0 !important;
  right: 0 !important;
  padding: 24px !important;
  padding-bottom: 16px !important;
  border-top: 1px solid #efefef !important;
  background: #efefef !important;

  .bottom-button-container {
    display: grid;
    grid-template-columns: 1fr;
    // text-align:center;
    // align-items: center;
  }
}
